import PremiumPayment from './PremiumPayment.vue';
import ReviewAndSubmit from './ReviewAndSubmit.vue';
import ClaimsAccount from './ClaimsAccount.vue';

const UpdatePaymentDetailsStepNames = Object.freeze({
  step1: 'PremiumPayment',
  step2: 'ClaimsAccount',
  step3: 'ReviewAndSubmit',
});

export { PremiumPayment, ClaimsAccount, ReviewAndSubmit, UpdatePaymentDetailsStepNames };
